import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

// Social media icons as SVG components for flexibility
const SocialIcon = ({ network, size = 18 }) => {
  const icons = {
    linkedin: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    facebook: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    x: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
    meetup: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M6.98 21.747c-.238.054-.476.054-.714.054a3.648 3.648 0 0 1-3.633-3.305l-.006-.072v-.116c.04-1.552.71-3.036 1.896-4.143 1.186-1.108 2.758-1.715 4.404-1.715.816 0 1.61.16 2.352.476.742.316 1.396.782 1.932 1.374a5.98 5.98 0 0 1 1.28 2.088c.272.796.357 1.635.249 2.456a5.72 5.72 0 0 1-.93 2.434 5.937 5.937 0 0 1-1.925 1.74 5.79 5.79 0 0 1-2.54.729h-.127a5.742 5.742 0 0 1-2.238 0zm4.047-8.507a4.013 4.013 0 0 0-2.855 1.186A4.013 4.013 0 0 0 6.99 17.28v.1c0 1.107.896 2.011 2.003 2.011h.1a3.94 3.94 0 0 0 1.54 0 3.98 3.98 0 0 0 1.747-.502 4.092 4.092 0 0 0 1.325-1.196 3.93 3.93 0 0 0 .64-1.675 4.11 4.11 0 0 0-.171-1.69 4.12 4.12 0 0 0-.88-1.437 3.927 3.927 0 0 0-1.33-.947 3.869 3.869 0 0 0-1.617-.328h-.1v.135-.135zM17.02 2.253a3.648 3.648 0 0 1 3.633 3.305l.006.072v.116a5.93 5.93 0 0 1-1.896 4.143 5.787 5.787 0 0 1-4.404 1.715 5.764 5.764 0 0 1-2.352-.476 5.802 5.802 0 0 1-1.932-1.374 5.98 5.98 0 0 1-1.28-2.088 5.81 5.81 0 0 1-.249-2.456 5.72 5.72 0 0 1 .93-2.434 5.937 5.937 0 0 1 1.925-1.74A5.79 5.79 0 0 1 14.54 2.3h.127a5.742 5.742 0 0 1 2.352-.047zm-4.047 8.507a4.013 4.013 0 0 0 2.855-1.186A4.013 4.013 0 0 0 17.01 6.72v-.1c0-1.107-.896-2.011-2.003-2.011h-.1a3.94 3.94 0 0 0-1.54 0 3.98 3.98 0 0 0-1.747.502 4.092 4.092 0 0 0-1.325 1.196 3.93 3.93 0 0 0-.64 1.675 4.11 4.11 0 0 0 .171 1.69c.178.557.48 1.056.88 1.437.4.38.878.675 1.33.947a3.869 3.869 0 0 0 1.617.328h.1V10.76z"/>
      </svg>
    ),
    instagram: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    tiktok: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    ),
    youtube: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    github: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
      </svg>
    ),
    discord: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/>
      </svg>
    ),
    telegram: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
      </svg>
    ),
    pinterest: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/>
      </svg>
    ),
    threads: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.33-3.022.88-.73 2.082-1.146 3.384-1.17 1.086-.02 2.09.156 2.986.523a6.667 6.667 0 0 1-.022-.582c-.024-.978-.298-1.72-.816-2.203-.49-.457-1.166-.685-2.012-.678-1.567.013-2.587.677-3.036 1.973l-1.924-.574c.63-1.968 2.378-3.266 4.941-3.28 1.375-.013 2.49.339 3.315 1.046.876.752 1.343 1.865 1.387 3.307.014.475-.012.934-.076 1.375.616.37 1.152.82 1.595 1.345.784.928 1.25 2.134 1.348 3.481.111 1.543-.238 2.94-1.036 4.151-1.094 1.657-2.936 2.733-5.478 3.198a13.96 13.96 0 0 1-2.38.183zm.086-11.907c-1.026.03-1.86.305-2.412.793-.51.452-.755 1.04-.727 1.744.04.702.364 1.254.967 1.644.57.369 1.31.529 2.143.464 1.094-.085 1.943-.479 2.527-1.172.474-.562.793-1.327.95-2.278-.891-.334-1.895-.493-2.99-.5a8.62 8.62 0 0 0-.458.005z"/>
      </svg>
    ),
    email: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
      </svg>
    ),
  };

  return icons[network] || icons.email;
};

const Footer = () => {
  const [settings, setSettings] = useState(null);
  const [footerColumns, setFooterColumns] = useState([]);
  const [legalLinks, setLegalLinks] = useState([]);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const fetchData = useCallback(async () => {
    try {
      const [settingsRes, footerRes, legalRes] = await Promise.all([
        api.get('/settings'),
        api.get('/footer'),
        api.get('/footer-menu'),
      ]);
      setSettings(settingsRes.data);
      setFooterColumns(footerRes.data);
      setLegalLinks(legalRes.data?.items || []);
    } catch (error) {
      console.error('Failed to fetch footer data:', error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Handle internal navigation
  const handleLinkClick = (e, url) => {
    if (url.startsWith('/') && !url.startsWith('//')) {
      e.preventDefault();
      navigate(url);
    } else if (url.startsWith('#')) {
      e.preventDefault();
      const element = document.getElementById(url.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  // Fallback links if no footer columns are set up
  const defaultFooterLinks = {
    Events: [
      { label: 'Brooklyn Tech Expo', url: '/brooklyn-tech-expo' },
      { label: 'AI Week New York', url: '/ai-week' },
    ],
    Community: [
      { label: 'Meetup Groups', url: '#meetups' },
      { label: 'Tech News', url: '#news' },
      { label: 'Event Gallery', url: '#gallery' }
    ],
    Company: [
      { label: 'About Us', url: '/about' },
      { label: 'Contact', url: '#newsletter' },
    ]
  };

  // Use CMS footer columns if available, otherwise use defaults
  const footerData = footerColumns.length > 0
    ? footerColumns.reduce((acc, col) => {
        acc[col.title] = col.links;
        return acc;
      }, {})
    : defaultFooterLinks;

  // Get social links from settings or use defaults
  const socialLinks = settings?.social_links?.length > 0 
    ? settings.social_links 
    : [
        { id: '1', network: 'x', url: '#' },
        { id: '2', network: 'linkedin', url: '#' },
        { id: '3', network: 'github', url: '#' },
      ];

  // Get footer tagline
  const footerTagline = settings?.footer_tagline || 
    "NYC's Premier Tech Community - Connecting innovators, entrepreneurs, and tech enthusiasts.";

  return (
    <footer className="bg-gray-900 text-gray-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            {settings?.logo_url_light ? (
              <img
                src={settings.logo_url_light}
                alt={settings?.site_name || 'Pulse NYC'}
                style={{ height: `${settings?.logo_size || 40}px` }}
                className="object-contain mb-4"
                data-testid="footer-logo-light"
              />
            ) : (
              <h3 className="text-2xl font-bold text-white mb-4" data-testid="footer-site-name">
                {settings?.site_name || 'Pulse NYC'}
              </h3>
            )}
            <p className="text-gray-400 mb-6 max-w-sm" data-testid="footer-tagline">
              {footerTagline}
            </p>
            {/* Social Links */}
            <div className="flex flex-wrap gap-3" data-testid="footer-social-links">
              {socialLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.url}
                  className="w-10 h-10 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors duration-200"
                  data-testid={`footer-social-${link.network}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={link.network.charAt(0).toUpperCase() + link.network.slice(1)}
                >
                  <SocialIcon network={link.network} size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerData).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-white font-semibold mb-4">{category}</h4>
              <ul className="space-y-2">
                {links.map((link, idx) => (
                  <li key={link.id || idx}>
                    <a
                      href={link.url}
                      onClick={(e) => handleLinkClick(e, link.url)}
                      className="text-gray-400 hover:text-gray-200 transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-testid="footer-copyright">
            {settings?.copyright_text || `© ${currentYear} Pulse NYC. All rights reserved.`}
          </p>
          {/* Legal Links from Footer Menu */}
          <div className="flex space-x-6 text-sm" data-testid="footer-legal-links">
            {legalLinks.length > 0 ? (
              legalLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.url}
                  onClick={(e) => handleLinkClick(e, link.url)}
                  className="text-gray-400 hover:text-gray-200 transition-colors"
                >
                  {link.label}
                </a>
              ))
            ) : (
              <>
                <a href="/privacy-policy" onClick={(e) => handleLinkClick(e, '/privacy-policy')} className="text-gray-400 hover:text-gray-200 transition-colors">
                  Privacy Policy
                </a>
                <a href="/terms-of-service" onClick={(e) => handleLinkClick(e, '/terms-of-service')} className="text-gray-400 hover:text-gray-200 transition-colors">
                  Terms of Service
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
